import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { makeGetIsSuspendedSelector } from "~/store/selectors/selector.configOptions";
import { makeIsLoggedUserOwnerSelector } from "~/store/selectors/selector.users";

export const NotSuspended = ({ children, redirectTo }) => {
  const getIsSuspended = useMemo(() => {
    return makeGetIsSuspendedSelector();
  }, []);
  const isAccountSuspended = useSelector(getIsSuspended);
  const isLoggedUserOwner = useMemo(() => {
    return makeIsLoggedUserOwnerSelector();
  }, []);
  const isOwner = useSelector(isLoggedUserOwner);

  return isAccountSuspended && !isOwner ? children : <Navigate to={redirectTo} />;
};

NotSuspended.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

NotSuspended.defaultProps = {
  redirectTo: "/projects",
};
